import { gray4 } from '../../../../styles/colors';
import { SvgIcon } from '../SvgIcon';

interface IProps {
	className?: string;
	fillColor?: string;
	size?: number;
}

export const TabSettingsIcon = ({ size = 20, className = '', fillColor = gray4 }: IProps) => {
	return (
		<SvgIcon width={size} height={size} fill='none' viewBox='0 0 20 20' className={className}>
			<path
				fill={fillColor}
				fillRule='evenodd'
				d='M17 2a1.001 1.001 0 0 1 0 2 1.001 1.001 0 0 1 0-2m0 4c1.654 0 3-1.346 3-3s-1.346-3-3-3a2.993 2.993 0 0 0-2.815 2H0v2h14.185A2.993 2.993 0 0 0 17 6M7 10a1.001 1.001 0 0 1 0-2 1.001 1.001 0 0 1 0 2m0-4a2.993 2.993 0 0 0-2.815 2H0v2h4.185A2.993 2.993 0 0 0 7 12a2.993 2.993 0 0 0 2.815-2H20V8H9.815A2.993 2.993 0 0 0 7 6m10 10a1.001 1.001 0 0 1 0-2 1.001 1.001 0 0 1 0 2m0-4a2.993 2.993 0 0 0-2.815 2H0v2h14.185A2.993 2.993 0 0 0 17 18c1.654 0 3-1.346 3-3s-1.346-3-3-3'
				clipRule='evenodd'
			/>
		</SvgIcon>
	);
};
